import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GuidedActionsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GuidedActions",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.52 15.05 9.87 9.99c-.43-.15-.9 0-1.15.38-.25.37-.23.87.07 1.21l3.77 4.4-3.77 4.4a.999.999 0 0 0 .76 1.65c.11 0 .22-.02.33-.05l14.65-5.06c.4-.14.67-.52.67-.95s-.27-.81-.67-.95Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2m0 25C9.93 27 5 22.07 5 16S9.93 5 16 5s11 4.93 11 11-4.93 11-11 11"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-8.83 0-16-7.18-16-16s7.17-16 16-16 16 7.17 16 16-7.18 16-16 16m0-29.72C8.3 2.14 2.15 8.29 2.15 15.85S8.3 29.56 15.86 29.56s13.71-6.15 13.71-13.71S23.42 2.14 15.86 2.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "m23.86 15.83-13.71-5.64 3.4 4.41c.58.75.58 1.79 0 2.55l-3.34 4.38z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.21 22.67c-.35 0-.68-.16-.91-.44-.32-.41-.32-.98 0-1.39l3.34-4.38a.96.96 0 0 0 0-1.16l-3.4-4.41c-.32-.41-.32-.98 0-1.39.31-.41.86-.56 1.34-.36l13.69 5.63c.28.11.52.33.65.63.24.58-.03 1.25-.61 1.5l-13.65 5.7c-.14.06-.29.09-.44.09Zm3.44-9.8.79 1.03c.89 1.16.9 2.78.01 3.94l-.75.99 7.17-2.99z"
      })]
    })
  }));
};
GuidedActionsIcon.displayName = 'GuidedActionsIcon';